export const appConfig = {
  name: 'El Divergente',
  shortName: 'Divergente',
  siteUrl: import.meta.env.VITE_PUBLIC_SITE_URL ?? 'https://eldivergente.pages.dev',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  locale: 'es-AR',
  region: 'Puerto San Julián, Santa Cruz'
} as const;
